import axios from 'axios';
import { apiRoutes } from '../../apiRoutes';
import { authHeader } from '../../global';

import Vue from 'vue'



const getDefaultStateForstorageclass = () => {
  return {
    storage_classifications: []
  }
}

// state
const state = getDefaultStateForstorageclass()

const getters = {

}

// mutations
const mutations = {
  
    FETCH_ALL(state, data){
        state.storage_classifications = data
    },
    RESET_STATE_FOR_STORAGECLASS (state) {
      Object.assign(state, getDefaultStateForstorageclass())
    },
}

// actions
const actions = {
    resetState({ commit, dispatch }, payload) {
      commit("RESET_STATE_FOR_STORAGECLASS")
    },
    fetchAll({ commit }, data) {
        return axios.post(apiRoutes['STORAGECLASS_LIST'], data, authHeader())
            .then(response => {
              if(response.data.code == 1){
                commit('FETCH_ALL', response.data.data)
              } else {
                commit('FETCH_ALL', [])
              }
            })
            .catch(error => {
              if (error.response) {
                  Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: error.response.data.msg,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
              } else {
                  console.log("Problem Querying Data!", error);
              }
          });
    },

}

export {
    state,
    getters,
    actions,
    mutations
}
